<script setup lang="ts">
import { mediaUrl } from '#imports'

export interface BingoTrustpilotReviewProps {
    reviewer: {
        avatar: string
        quote: string
        name: string
    }
    trustpilotImage?: string
}

const props = defineProps<BingoTrustpilotReviewProps>()
</script>

<template>
    <div class="trustpilot hide-in-percy">
        <NuxtImg
            preset="local"
            provider="cloudflare"
            class="trustpilot__reviewer-avatar"
            :src="props.reviewer.avatar"
            :alt="props.reviewer.name"
            width="266"
            height="232"
        />
        <div class="trustpilot__bubble">
            <q
                class="trustpilot__reviewer-quote"
                v-text="props.reviewer.quote "
            />
            <p
                class="trustpilot__reviewer-name"
                v-text="props.reviewer.name"
            />
        </div>

        <NuxtImg
            preset="local"
            provider="cloudflare"
            :src="mediaUrl('/media/trustpilot/trustpilot-logo.png')"
            sizes="115px md:178px lg:356px"
            class="trustpilot__logo"
            alt="Trustpilot logo"
            width="115"
            height="29"
            quality="70"
            decoding="async"
            loading="lazy"
        />
        <NuxtImg
            preset="local"
            provider="cloudflare"
            :src="props.trustpilotImage"
            sizes="115px md:178px lg:356px"
            class="trustpilot__rating"
            alt="Trustpilot rating"
            width="115"
            height="22"
            quality="70"
            decoding="async"
            loading="lazy"
        />
        <NuxtImg
            preset="local"
            provider="cloudflare"
            :src="mediaUrl('/media/trustpilot/winner-shine.png')"
            class="trustpilot__shine"
            alt="Background shine"
            width="480"
            height="480"
            quality="70"
            sizes="480px md:720px"
            decoding="async"
            loading="lazy"
        />
    </div>
</template>

<style lang="scss" scoped>
.trustpilot {
    position: relative;
    max-width: 276px;
    color: $gray-dark;

    @media (min-width: $screen-sm) {
        overflow: visible;
    }

    @media (min-width: $screen-md) {
        max-width: 414px;
    }

    @media (min-width: $screen-md) and (max-width: #{$screen-lg - 1}) {
        margin-top: 20px;
        // margin-left: auto;
        text-align: right;
    }

    @media (min-width: $screen-lg) {
        margin-left: unset;
    }

    &__reviewer-avatar {
        margin-left: 18px;
        object-position: center bottom;
        object-fit: contain;

        @media (min-width: $screen-md) {
            margin: -45px 18px 0;
        }
    }

    &__bubble {
        padding: 15px;
        border-radius: var(--border-radius, $border-radius);
        background: #fff;
    }

    &__reviewer-quote {
        font-size: 14px;
        font-weight: $text-semi-bold;
        font-style: italic;

        @media (min-width: $screen-md) {
            font-size: 22px;
        }
    }

    &__reviewer-name {
        margin: 15px 0 5px;
        color: $blue;
        font-size: 16px;
        font-weight: $text-bold;

        @media (min-width: $screen-md) {
            font-size: 25px;
        }
    }

    &__reviewer-winnings {
        margin: 0;
        color: #9a9a9a;
        font-size: 12px;
        font-weight: $text-medium;

        @media (min-width: $screen-lg) {
            font-size: 19px;
        }
    }

    &__logo,
    &__rating {
        display: block;
    }

    &__logo {
        margin: 15px 0 4px;

        @media (min-width: $screen-md) {
            width: 178px;
            height: 45px;
        }
    }

    &__rating {
        @media (min-width: $screen-md) {
            width: 178px;
            height: 34px;
        }
    }

    &__shine {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: -1;
        transform: translate3d(-50%, -50%, 0);
        width: 480px;
        height: auto;

        @media (min-width: $screen-md) {
            width: 720px;
            height: 720px;
        }
    }
}
</style>
